import React from "react";
import { Col, Form, Row } from "react-bootstrap";

import { formatDate } from "../../helper/helper";

const DependentsInfo = ({ DependentsInfoData, fields, append, remove }) => {
  console.log("DependentsInfoData", DependentsInfoData);
  return (
    <div className="wrapper mw-100 position-relative mb-5 pb-2 px-md-4 px-3">
      <span className="wrapper-heading">Other Family Members</span>
      {DependentsInfoData?.familyInformation?.map((item, index) => (
        <div key={index} className={`border p-3 ${index !== 0 && "mt-3"}`}>
          <Row className="mb-3 gx-sm-3 gx-2">
            <Col xl={3} md={4} xs={6} className="mb-3">
              <Form.Group key={item.id} controlId={`formSurname${index}`}>
                <Form.Label className="fw-bold">Member name</Form.Label>
                <div>
                  {item?.firstName} {item?.lastName}{" "}
                </div>
              </Form.Group>
            </Col>

            <Col xl={3} md={4} sm={6} className="mb-3">
              <Form.Group key={item.id} controlId={`formEmail${index}`}>
                <Form.Label className="fw-bold">Date of Birth</Form.Label>
                <div>{formatDate(item?.dob) || "-"}</div>
              </Form.Group>
            </Col>

            <Col xl={3} md={4} sm={6} className="mb-3">
              <Form.Group
                className=""
                key={item.id}
                controlId={`formDesignation${index}`}
              >
                <Form.Label className="fw-bold">Relation With</Form.Label>
                <div>{item?.relationWith || "-"}</div>
              </Form.Group>
            </Col>

            <Col xl={3} md={4} sm={6} className="mb-3">
              <Form.Group key={item.id} controlId={`formDepartment${index}`}>
                <Form.Label className="fw-bold">Office/Department</Form.Label>
                <div>{item?.department || "-"}</div>
              </Form.Group>
            </Col>

            <Col xl={3} md={4} sm={6} className="mb-3">
              <Form.Group key={item.id} controlId={`formEducation${index}`}>
                <Form.Label className="fw-bold">Education</Form.Label>
                <div>{item?.education || "-"}</div>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group key={item.id} controlId={`formSubscription${index}`}>
                <Form.Label className="fw-bold">Marital Status</Form.Label>
                <div>{item?.maritalStatus || "-"}</div>
              </Form.Group>
            </Col>
          </Row>
        </div>
      ))}
    </div>
  );
};

export default DependentsInfo;
